module.exports = __webpack_public_path__ + "public/img/customer_service.1252c3e5.svg";